// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formulate-input-errors{color:red}.messageItem .v-chip__content{white-space:pre-wrap}.messageItem .v-chip{min-height:32px;height:auto}.chat-message-chip.chat-message-is-mine a{color:#ffcc80}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
